module.exports = __webpack_public_path__ + "img/team-blue.bc10b28c.svg";